import { render, staticRenderFns } from "./DocsNavigationMenuItem.vue?vue&type=template&id=d682b05a&scoped=true&"
import script from "./DocsNavigationMenuItem.vue?vue&type=script&lang=js&"
export * from "./DocsNavigationMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./DocsNavigationMenuItem.vue?vue&type=style&index=0&id=d682b05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d682b05a",
  null
  
)

export default component.exports